import AppTheme from 'docs/src/modules/components/AppTheme';
import SignUp from 'docs/src/pages/premium-themes/onepirate/SignUp';

export default function Page() {
  return (
    <AppTheme title="Onepirate theme - MUI" description="A onepirate theme">
      <SignUp />
    </AppTheme>
  );
}
